import React from 'react';

import type {ButtonProps, IconSource} from '@pexip/components';
import {BadgeCounter, Icon} from '@pexip/components';

import type {InMeetingInputControlProps} from '../InputControl/InMeetingInputControl.view';
import {InMeetingInputControl} from '../InputControl/InMeetingInputControl.view';

export const InputControlToggleView: React.FC<
    ButtonProps & {
        isActive: boolean;
        count?: number;
        actionCount?: number;
        shouldAnimate?: boolean;
        isTouchDevice?: boolean;
        badgeTestId?: string;
        buttonTestId?: string;
        ariaLabel: string;
        tooltipText: string;
        icon: IconSource;
        tooltipPosition?: InMeetingInputControlProps['tooltipPosition'];
    }
> = ({
    isActive,
    count = 0,
    actionCount = 0,
    shouldAnimate = false,
    isTouchDevice = false,
    ariaLabel,
    tooltipText,
    icon,
    badgeTestId = '',
    buttonTestId = '',
    tooltipPosition = 'right',
    ...props
}) => {
    const showNotifications = !isActive && actionCount > 0;
    return (
        <BadgeCounter
            data-testid={badgeTestId}
            variant="info"
            isTruncated={showNotifications}
            isVisible={count > 0}
            number={count}
            shouldAnimate={shouldAnimate}
        >
            <InMeetingInputControl
                aria-label={ariaLabel}
                data-testid={buttonTestId}
                tooltipText={tooltipText}
                tooltipPosition={tooltipPosition}
                shouldShowTooltip={!isTouchDevice}
                icon={<Icon source={icon} size="small" />}
                isActive={isActive}
                {...props}
            />
        </BadgeCounter>
    );
};
export type InputControlToggleViewProps = React.ComponentProps<
    typeof InputControlToggleView
>;
